<hlm-alert-dialog [state]="state()">
  <hlm-alert-dialog-content *brnAlertDialogContent="let ctx">
    <button
      type="button"
      (click)="close()"
      aria-label="Schließen"
      class="absolute top-4 right-4 text-muted-foreground hover:text-foreground"
    >
      <ng-icon name="lucideX" size="16" />
    </button>

    <hlm-alert-dialog-header class="pb-2 pr-6">
      <h2 hlmAlertDialogTitle class="text-lg font-bold">Keine Dachflächen gefunden</h2>
      <p hlmAlertDialogDescription class="text-sm text-muted-foreground mt-1">
        Für die Planung werden erkannte Dachflächen benötigt. Wie möchtest du fortfahren?
      </p>
    </hlm-alert-dialog-header>

    <div class="flex flex-col gap-2.5 py-1">
      <button
        type="button"
        (click)="chooseDraw()"
        class="flex items-start gap-3 rounded-md border border-primary/30 bg-primary/5 p-3.5 text-left transition-colors hover:bg-primary/10"
      >
        <div class="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-primary/10 text-primary">
          <ng-icon name="lucidePencilRuler" size="16" />
        </div>
        <div class="min-w-0">
          <div class="flex items-center gap-2 flex-wrap">
            <span class="text-sm font-normal">Dachflächen einzeichnen</span>
            <span class="rounded-full bg-primary/10 px-2 py-0.5 text-2xs font-normal text-primary">Empfohlen</span>
          </div>
          <p class="text-xs text-muted-foreground mt-0.5">
            Meist genauer als eine erneute automatische Erkennung.
          </p>
        </div>
      </button>

      <button
        type="button"
        (click)="chooseRerun()"
        class="flex items-start gap-3 rounded-md border border-border p-3.5 text-left transition-colors hover:bg-muted/50"
      >
        <div class="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-muted text-muted-foreground">
          <ng-icon name="lucideRotateCcw" size="16" />
        </div>
        <div class="min-w-0">
          <span class="text-sm font-normal">Erkennung erneut ausführen</span>
          <p class="text-xs text-muted-foreground mt-0.5">
            Startet die automatische Objekterkennung neu.
          </p>
        </div>
      </button>
    </div>
  </hlm-alert-dialog-content>
</hlm-alert-dialog>
